import { ChangeDetectionStrategy, Component, DestroyRef, inject, Input } from '@angular/core';
import { TableColumn, ButtonComponent } from '@ui/aos-lib';
import { ReportGroups, GroupStatus, ReportGroupsPageContext } from '../../report-groups.types';
import { ReportGroupsApiService } from '../../services/report-groups-api.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  template: `
    <ui-button
      [iconName]="'pencil'"
      [size]="'small'"
      [disabled]="isDisabled"
      (clicked)="onColumnClick()"
    ></ui-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent]
})
export class ReportGroupsEditModalColumnComponent {
  private readonly reportGroupsPageComponent = inject(ReportGroupsPageContext, { optional: true });

  protected readonly nonDeletableAttributeName = 'GroupType';
  protected readonly nonDeletableAttributeValue = 'Default';
  private readonly reportGroupsApiService = inject(ReportGroupsApiService);
  private readonly destroyRef = inject(DestroyRef);

  @Input() item!: ReportGroups;
  @Input() column!: TableColumn;

  protected onColumnClick(): void {
    const { groupUID, groupName, groupDescription, groupStatus, applicable, commodity } = this.item;

    this.reportGroupsApiService
      .getReportGroupDetails(groupUID)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(data => {
        const { groupCriteria } = data;
        this.reportGroupsPageComponent!.editReportGroupFormData = {
          groupUID,
          groupName,
          groupDescription,
          groupStatus,
          applicable,
          commodity,
          groupCriteria
        };
        this.reportGroupsPageComponent!.groupUID = groupUID;
        this.reportGroupsPageComponent!.openModal();
      });
  }

  protected get isDisabled(): boolean {
    return (
      this.item.groupStatus === GroupStatus.Calculating ||
      this.item.groupAttributes.some(
        item => item.name === this.nonDeletableAttributeName && item.values[0] === this.nonDeletableAttributeValue
      )
    );
  }
}
